import { AgenciaRoutingModule } from './agencia-routing.module';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { AgenciaDetalheComponent } from './agencia-detalhe/agencia-detalhe.component';
import { AgenciaComponent } from './agencia.component';


@NgModule({
  declarations: [AgenciaComponent, AgenciaDetalheComponent],
  imports: [
    SharedModule,
    AgenciaRoutingModule
  ]
})
export class AgenciaModule { }
